export default "__VITE_ASSET__DGM2fKS$__"